import { connect } from 'react-redux';

import ArtifactHealthDoughnutComponent
  from './../Components/ArtifactHealthDoughnutComponent.jsx';
import { artifactHealth } from './../helpers';
import { getArtifactHealthPlatform } from './../reducers';

export const mapStateToProps = (state, ownProps) => {
  const platformData = getArtifactHealthPlatform(state, ownProps.platform);
  return {
    title: ownProps.platform,
    pieData: platformData ? [
      platformData.allGood,
      platformData.needsVerification,
      platformData.needsData,
      platformData.probablyBroken,
      platformData.unknown
    ] : [],
    pieSlices: artifactHealth.ARTIFACT_HEALTH_STATUSES.map(status => ({
      label: status.name,
      colour: status.color
    }))
  };
};

export default connect(
  mapStateToProps
)(ArtifactHealthDoughnutComponent);


// WEBPACK FOOTER //
// src/Containers/ArtifactHealthDoughnutContainer.jsx